var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"currentColor","x":"9.85547","y":"9.4209","width":"6","height":"6","key":0}),React.createElement("rect",{"fill":"currentColor","x":"9.85547","y":"2.4209","width":"6","height":"6","key":1}),React.createElement("rect",{"fill":"currentColor","x":"9.85547","y":"16.4209","width":"6","height":"6","key":2})]);
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 25"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
